import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { CancelCardStackRoutes, CancelCardStackScreenProps } from './type';
import { CancelCardWebTwoScreen } from './CancelCardWebTwo.screen';
import { CancelCardNativeTwoScreen } from './CancelCardNativeTwo.screen';

export interface CancelCardProps {}
export const CancelCardPlaced: React.FC<CancelCardStackScreenProps<CancelCardStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, account, tab, returnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <CancelCardNativeTwoScreen onClose={onGoBack} data={data} account={account} tab={tab} returnData={returnData} refresh={refresh} />
    );
  }

  return (
    <CancelCardWebTwoScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      account={account}
      tab={tab}
      returnData={returnData}
      refresh={refresh}
    />
  );
};
